export default __webpack_public_path__ + "static/media/successful-young-couple-becoming-homeowner.652575cd.jpg";